import React from 'react'
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazy-load'
import CalendarThumb from './CalendarThumb.jpg'
import {CLIENT_BASE_URL} from '../../actions'
const calendarThumbs = [CalendarThumb]

export class ProgramItem extends React.Component {
  getCalendarThumb (pos) {
    return {
      backgroundImage: `url('${calendarThumbs[pos]}')`
    }
  }

  getThumbUrl (thumb) {
    return `${CLIENT_BASE_URL}${thumb}`
  }

  renderTagName (tag, ismovie) {
    if (ismovie === '1') {
      return (
        <p>{tag}</p>
      )
    } else {
      return (
        <p className='is-activity'>EVENTOS PARALELOS</p>
      )
    }
  }

  getProgItemMainClass (highlight) {
    if (highlight === '1') {
      return 'program-item col-md-3 active'
    }

    return 'program-item col-md-3'
  }

  render () {
    const {movie} = this.props
    // console.log('movie', movie)
    return (
      <div className={this.getProgItemMainClass(movie.highlight)}>
        <p className='hh'>{`${movie.hh}`}</p>
        <div className='img-container'>
          <LazyLoad offsetHorizontal={1000} offsetVertical={300}>
            <img className='thumb' src={this.getThumbUrl(movie.thumb)} />
          </LazyLoad>
          <div className='thumb-ovr' />
        </div>
        <div className='details'>
          <p>{movie.title}</p>
          <p>{movie.keywords}</p>
          <p className='logline'>{movie.logline}</p>
        </div>
        <div className='tags'>
          <p>{movie.venue}</p>
          {this.renderTagName(movie.tag, movie.ismovie)}
        </div>
      </div>
    )
  }
}

ProgramItem.propTypes = {
  movie: PropTypes.shape({
    id: PropTypes.any.isRequired,
    title: PropTypes.string.isRequired,
    thumb: PropTypes.string.isRequired,
    venue: PropTypes.string.isRequired,
    hh: PropTypes.string.isRequired,
    logline: PropTypes.string.isRequired
  }).isRequired
}



// WEBPACK FOOTER //
// ./src/views/ProgramView/ProgramItem.js